import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CoreConfig } from 'src/app/models/core-config.model';
import { AuthService } from '../auth.service';

@Component({
  templateUrl: './page-not-found.html',
  standalone: false,
})
export class PageNotFoundComponent {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {
    this.config = this.authService.getCoreConfig();
  }

  config!: CoreConfig;

  return() {
    this.router.navigate([this.config.redirectPathAfterLogin]);
  }
}
